import { render } from "./paid-vip.vue?vue&type=template&id=42ab653f&scoped=true&ts=true"
import script from "./paid-vip.vue?vue&type=script&lang=ts"
export * from "./paid-vip.vue?vue&type=script&lang=ts"

import "./paid-vip.vue?vue&type=style&index=0&id=42ab653f&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ab653f"]])

export default __exports__